import React, { FC, useContext } from 'react';

import { Separator, Toggle } from '@smartshell/ui-kit';

import { SettingsLock, TimeOutInput } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const CallAdmin: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('call_admin');

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        label={t('setting.calls')}
        description={t('settings.shell.client.call.description')}
        value={settings.callAdmin}
        onChange={(value: string) => {
          setSetting({
            alias: ESettingsAliases.CALL_ADMIN,
            value: value ? '1' : '0',
          });
        }}
        variant="secondary"
        emptyBg
        disabled={!isAvailable}
        rightContent={!isAvailable ? <SettingsLock /> : undefined}
      />
      <Separator style={{ margin: '16px 0' }} />
      <TimeOutInput
        label={t('setting.calls.headroom')}
        description={t('settings.shell.client.call.time')}
        setting={settings.callAdminTimeout}
        updateSetting={setSetting}
        settingAlias={ESettingsAliases.CALL_ADMIN_TIMEOUT}
        inMinutes
        disabled={settings.callAdmin}
      />
    </>
  );
};
